import {Button, Menu, Typography} from "@mui/material";
import {RichTreeView} from "@mui/x-tree-view";
import {useEffect, useMemo, useState} from "react";

export const BusinessUnitPicker = ({businessUnits, businessUnitSetter, filters}) => {
    const [anchorElement, setAnchorElement] = useState(null);
    const [idToNameMap, setIdToNameMap] = useState({ALL: 'ALL'});
    const [selectedIds, setSelectedIds] = useState(['ALL']);
    const [selectedName, setSelectedName] = useState('ALL');

    const treeItems = useMemo(
        () => [{id: 'ALL', label: 'ALL'}, ...businessUnits.map((bu) => ({id: bu.id, label: bu.name}))],
        [businessUnits]
    );

    useEffect(() => {
        const nextMap = {ALL: 'ALL'};
        for (const bu of businessUnits) {
            nextMap[bu.id] = bu.name;
            nextMap[String(bu.id)] = bu.name;
        }
        setIdToNameMap(nextMap);
    }, [businessUnits]);

    useEffect(() => {
        if (!filters.businessUnitId) {
            setSelectedIds(['ALL']);
            setSelectedName('ALL');
            return;
        }
        setSelectedIds([filters.businessUnitId]);
        setSelectedName(idToNameMap[filters.businessUnitId] ?? idToNameMap[String(filters.businessUnitId)] ?? 'ALL');
    }, [filters.businessUnitId, idToNameMap]);

    const handleClick = (event) => {
        setAnchorElement(event.currentTarget);
    };

    const handleSelection = (event, id) => {
        setAnchorElement(null);
        if (id === selectedIds) {
            return;
        }
        setSelectedIds([id]);
        setSelectedName(idToNameMap[id] ?? 'ALL');
        businessUnitSetter(id);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return (
        <div>
            <Typography variant="h7" display="inline">Business Unit:</Typography>
            <Button onClick={handleClick}>{selectedName}</Button>
            <Menu id="businessUnitPickerMenu" anchorEl={anchorElement} keepMounted open={Boolean(anchorElement)}
                  onClose={handleClose}>
                <RichTreeView
                    items={treeItems}
                    selectedItems={selectedIds}
                    onSelectedItemsChange={handleSelection}
                    checkboxSelection
                />
            </Menu>
        </div>
    );
};
